import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function AllNews() {
    const [berita, setBerita] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Fetch ALL news from new endpoint
        fetch("https://api.rf-funserver.my.id/api/berita/all")
            .then((res) => res.json())
            .then((data) => {
                setBerita(data);
                setLoading(false);
            })
            .catch(() => {
                console.error("Gagal memuat berita");
                setLoading(false);
            });
    }, []);

    if (loading) {
        return (
            <div className="min-h-screen bg-gradient-to-b from-gray-900 via-gray-800 to-black text-white flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-orange-500 mx-auto mb-4"></div>
                    <p className="text-gray-400">Memuat berita...</p>
                </div>
            </div>
        );
    }

    return (
        <div className="bg-gradient-to-b from-gray-900 via-gray-800 to-black text-white min-h-screen">
            {/* Header */}
            <section className="bg-gray-900/50 border-b border-gray-700 py-16">
                <div className="max-w-6xl mx-auto px-4 text-center">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-orange-400 mb-4">
                        📰 Semua Berita & Update
                    </h1>
                    <p className="text-xl text-gray-300">
                        Update terbaru seputar RF FUN SERVER
                    </p>
                </div>
            </section>

            {/* News Grid */}
            <section className="py-16 px-4 md:px-12">
                <div className="max-w-6xl mx-auto">
                    {berita.length > 0 ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                            {berita.map((item) => (
                                <Link
                                    key={item.id}
                                    to={`/blog/${item.slug}`}
                                    className="bg-gray-800 rounded-lg overflow-hidden border border-gray-700 hover:border-orange-400 transition transform hover:scale-105 hover:shadow-2xl"
                                >
                                    {item.thumbnail && (
                                        <img
                                            src={item.thumbnail}
                                            alt={item.judul}
                                            className="h-48 w-full object-cover"
                                        />
                                    )}
                                    <div className="p-6">
                                        <div className="text-sm text-gray-400 mb-2">
                                            {new Date(item.created_at).toLocaleDateString('id-ID', {
                                                day: 'numeric',
                                                month: 'long',
                                                year: 'numeric'
                                            })}
                                        </div>
                                        <h3 className="text-orange-400 font-semibold mb-3 text-lg line-clamp-2">
                                            {item.judul}
                                        </h3>
                                        <p className="text-sm text-gray-400 mb-4 line-clamp-3">
                                            {item.excerpt}
                                        </p>
                                        <div className="text-orange-500 hover:text-orange-300 text-sm font-semibold flex items-center gap-2">
                                            Baca Selengkapnya
                                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                            </svg>
                                        </div>
                                    </div>
                                </Link>
                            ))}
                        </div>
                    ) : (
                        <div className="text-center py-16">
                            <div className="text-6xl mb-4">📭</div>
                            <h3 className="text-2xl font-bold mb-2">Belum Ada Berita</h3>
                            <p className="text-gray-400">
                                Tunggu update berita terbaru dari kami!
                            </p>
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
}

export default AllNews;
